import { Component, OnInit, Input, OnChanges } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { HandleError } from '../../../../components/common/utils/handleError.component';
import { PolizaEntity } from '../../entities/polizas_cliente_entity';
import { VamTitularEntity } from '../../../vam/titulares/entities/vam_titulares_entity';
import { SolicitudInclusionService } from './solicitud-inclusion.service';
import { PlanVam } from '../../entities/vam_entities';
import { SessionStorageService } from "ngx-webstorage";
import { MovimientosVamService } from '../movimientos/movimientosVam.service';

const swal = require("sweetalert2");



@Component({
    selector: 'solicitudMovimientos',
    templateUrl: 'solicitudes-movimientos.template.html',
    styleUrls: ['solicitudes.style.css']
})

export class SolicitudMovimientosComponent implements OnChanges {
    @Input() polizaContratada: PolizaEntity;
    planesVam: PlanVam[];
    showLoader: string;
    nombresPlanes: string[];
    planSeleccionado: number;
    planVam: PlanVam;
    polizaContratadaVam: PolizaEntity;
    planVamNombre: string;
    numeroPlan: number;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private handleError: HandleError,
        public movimientosService: MovimientosVamService,
        public sesionStorageService: SessionStorageService
    ) { }

    ngOnChanges() {
        this.sesionStorageService.store('polizaSelecionada', JSON.stringify(this.polizaContratada));
       
    }
    movimientos(){
        this.numeroPlan = this.planSeleccionado;
        this.polizaContratada.CodigoPlan = this.numeroPlan;
        this.polizaContratadaVam = this.polizaContratada;
        this.planVamNombre = this.planesVam.filter(a=>a.CodigoPlan == this.planSeleccionado)[0].Nombre;
    }
}


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/empresas/vamEmpresa/solicitudes/solicitudes-movimientos.component.ts